import { createAction } from 'redux-actions';

export const SET_CURRENT_VIDEO_ID = 'SET_CURRENT_VIDEO_ID';
export const setCurrentVideoId = createAction<string | null>(
  SET_CURRENT_VIDEO_ID,
);
